export enum ColumnId {
  JobId = 'JobId',
  Customer = 'Customer',
  JobName = 'JobName',
  CompanyName = 'CompanyName',
  Pro = 'Pro',
  ProEmail = 'ProEmail',
  AccessMethod = 'AccessMethod',
  Action = 'Action',
  TimeInAction = 'TimeInAction',
}

export type SearchableBookkeepingManagerSortField = 'date_pending_since' | 'id'

export type BookkeepingManagerColumnDetails = {
  id: ColumnId
  header: string
  align: 'left' | 'right' | 'center'
  select: boolean
  sortable: boolean
  field?: SearchableBookkeepingManagerSortField
}

export const BookkeepingManagerTableColumns: BookkeepingManagerColumnDetails[] =
  [
    {
      id: ColumnId.JobId,
      header: 'Job ID',
      select: false,
      align: 'left',
      sortable: false,
    },
    {
      id: ColumnId.Customer,
      header: 'Customer',
      select: false,
      align: 'left',
      sortable: false,
    },
    {
      id: ColumnId.JobName,
      header: 'Job name',
      select: false,
      align: 'left',
      sortable: false,
    },
    {
      id: ColumnId.CompanyName,
      header: 'Company name',
      select: false,
      align: 'left',
      sortable: false,
    },
    {
      id: ColumnId.Pro,
      header: 'Pro',
      select: false,
      align: 'left',
      sortable: false,
    },
    {
      id: ColumnId.ProEmail,
      header: 'Pro email address',
      select: false,
      align: 'left',
      sortable: false,
    },
    {
      id: ColumnId.AccessMethod,
      header: 'Method',
      select: false,
      align: 'left',
      sortable: false,
    },
    {
      id: ColumnId.Action,
      header: 'Action',
      select: false,
      align: 'right',
      sortable: false,
    },
    {
      id: ColumnId.TimeInAction,
      header: 'Time in action',
      field: 'date_pending_since',
      select: false,
      align: 'left',
      sortable: true,
    },
  ]
